export default __webpack_public_path__ + "static/media/practice-test-1.0e347d43.csv";